import type { AcademySport } from '@court-sync/shared';
import { cn } from '@/lib/utils';
import {
  getAcademySportDisplayLabel,
  getSportBadgeClasses,
} from '@/lib/sportPresentation';
import { SportGlyph } from './SportGlyph';

export interface SportBadgeProps {
  sport: Pick<AcademySport, 'sportId' | 'customLabel'>;
  className?: string;
  showIcon?: boolean;
  size?: 'sm' | 'md';
}

export function SportBadge({
  sport,
  className,
  showIcon = true,
  size = 'sm',
}: SportBadgeProps) {
  const label = getAcademySportDisplayLabel(sport);
  const iconClassName = size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium',
        getSportBadgeClasses(sport.sportId),
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
        className
      )}
    >
      {showIcon ? <SportGlyph sportId={sport.sportId} className={iconClassName} /> : null}
      {label}
    </span>
  );
}
